import React, { useEffect } from 'react';
import RetailOrderGrid from '../../../features/dealer/retail-order-grid/components/RetailOrderGrid';
import { useTitle } from "../../../contexts/title";
import OrderTypeSelector from '../../../features/dealer/order-type-selector/components/OrderTypeSelector';

export default function VanityOrdersPage() {

	const pageTitle = useTitle();
	useEffect(() => {
		pageTitle.setTitle('Vanity Orders')
	}, [pageTitle]);

	return (
		<React.Fragment>
			<div className={'content-block'}>
				<OrderTypeSelector />
				<RetailOrderGrid
					vanityOrders={true}
					imeOrders={undefined}
				/>
			</div>
		</React.Fragment>
	)
} 
